import * as types from "./types";

/**
 *
 * Store/Reset/Remove data dynamically based on .
 * @param {Object} data - API response on success/error/loading
 * @param {String} type - type for sucess/error/loading
 */

export const onThemeListSuccess = (
  payload = {},
  type = types.SUCCESS_THEME_LIST
) => {
  return {
    type,
    payload
  };
};

export const isThemeDataLoading = (
  payload = {},
  type = types.LOADING_THEME_LIST
) => {
  return {
    type,
    payload
  };
};

export const onPreviewDataSuccess = (
  payload = {},
  type = types.PREVIEW_DATA_SUCCESS
) => {
  return {
    type,
    payload
  };
};

export const onTaggingSuccess = (
  payload = {},
  type = types.PREVIEW_DATA_SUCCESS
) => {
  return {
    type,
    payload
  };
};

export const onUploadProgress = (
  payload = {},
  type = types.UPLOAD_PROGRESS
) => {
  return {
    type,
    payload
  };
};
